export default abstract class ApiServiceBase {
  protected static async makeApiCall<T>(apiCallPromise: () => Promise<T>): Promise<T> {
    const result = await apiCallPromise();
    return result;
  }
}
